module.exports = __webpack_public_path__ + "static/media/cloud-data-upload-icon.18a664e3.svg";